'use strict';

// Libraries
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import Odometer from 'odometer';
import 'odometer/themes/odometer-theme-default.css';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import "./styles/main.scss";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, SplitText);

// Expose libraries globally for module scripts
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;
window.Lenis = Lenis;
window.Splide = Splide;
window.Odometer = Odometer;
window.Fancybox = Fancybox;

// Init Fancybox
Fancybox.bind('[data-fancybox]');

// Import module scripts
import './scripts/modules/animations.js';
import './scripts/modules/odometer-init.js';
import './scripts/modules/splide-init.js';
import './scripts/modules/accordion.js';
import './scripts/modules/tabs.js';
import './scripts/modules/video-create.js';
import './scripts/modules/exit-popup.js';
import './scripts/modules/contact-popup.js';


window.addEventListener('DOMContentLoaded', function () {

	//mobile nav
	const burger = document.querySelector('.js-burger');
	const body = document.querySelector('body');
	const overlay = document.querySelector('.box-overlay');
	const navMobile = document.querySelector('.js-nav');


	burger.addEventListener('click', function () {
		this.classList.toggle('is-active');
		navMobile.classList.toggle('is-active');
		overlay.classList.toggle('is-active');
		body.classList.toggle('menu-show');

		if (body.classList.contains('menu-show')) {
			if (window.innerWidth <= 991) {
				window.scrollTo(0, 0);
				window.lenis?.scrollTo(0, { immediate: true });
			}
			window.lenis?.stop();
		} else {
			window.lenis?.start();
		}
	});

	overlay.addEventListener('click', function () {
		this.classList.toggle('is-active');
		navMobile.classList.toggle('is-active');
		burger.classList.toggle('is-active');
		body.classList.toggle('menu-show');

		if (body.classList.contains('menu-show')) {
			if (window.innerWidth <= 991) {
				window.scrollTo(0, 0);
				window.lenis?.scrollTo(0, { immediate: true });
			}
			window.lenis?.stop();
		} else {
			window.lenis?.start();
		}
	});

	navMobile.addEventListener('click', function (e) {
		if (!e.target.closest('a, button')) return;
		if (!body.classList.contains('menu-show')) return;

		burger.classList.remove('is-active');
		navMobile.classList.remove('is-active');
		overlay.classList.remove('is-active');
		body.classList.remove('menu-show');
		window.lenis?.start();
	});
});